import { IconButton, Menu } from '@taskall/react';
import { Drawer } from '@taskall/ui';
import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Brand } from '@/components/Brand';
import { Sidebar } from './Sidebar';
import { pageTitle } from './nav';

/** Layout administrativo: sidebar fixa (desktop) e drawer (≤ 1023px). */
export function AppShell() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const mainRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    setOpen(false);
    mainRef.current?.focus({ preventScroll: true });
    window.scrollTo({ top: 0 });
    document.title = pageTitle(location.pathname);
  }, [location.pathname]);

  return (
    <div className="taskall-app-root">
      <a
        href="#conteudo"
        className="sr-only z-[90] rounded bg-[var(--taskall-background-primary)] px-3 py-2 focus:not-sr-only focus:fixed focus:left-3 focus:top-3"
      >
        Pular para o conteúdo
      </a>
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-[var(--taskall-border-subtle)] bg-[var(--taskall-background-primary)] lg:block">
        <Sidebar />
      </aside>
      <header className="sticky top-0 z-40 flex h-14 items-center gap-3 border-b border-[var(--taskall-border-subtle)] bg-[var(--taskall-background-primary)] px-4 lg:hidden">
        <IconButton icon={Menu} aria-label="Abrir menu" tone="neutral" visualStyle="light" size="small" onClick={() => setOpen(true)} />
        <Brand size="sm" />
      </header>
      <Drawer open={open} onOpenChange={setOpen} title="Menu">
        <Sidebar onNavigate={() => setOpen(false)} />
      </Drawer>
      <main id="conteudo" ref={mainRef} tabIndex={-1} className="outline-none lg:pl-64">
        <div className="w-full px-4 py-6 sm:px-6 lg:px-10 lg:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
